import React, { useState, useCallback, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Container, Buttons, HeaderContainer, BackButton, ValidationAlert } from '../../style';
import { SmallInput, PageHeader, Button } from 'scorer-ui-kit';

import useLocalStorage from '../../hooks/useLocalstorage';
import { MenuContext, PathContext } from '../../App';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const InputContainer = styled.div`
  display: flex;
  width: inherit;
  margin: 5px 0 0 0;
  justify-content: space-between;
`;

const TasksListTitle = styled.div`
  display: flex;
  width: inherit;
  margin: 5px 0 0 0;
  justify-content: space-between;
  padding: 20px 0 0 0;
  border-top: 1px solid grey;
`;

const SelectFieldBox = styled.select`
  width: 104px;
  height: 30px;
  padding: 0 0 0 10px;
  border-radius: 3px;
  outline: none;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 14px;
  color: #767676;
  margin-top: 5px;
`;

const Position = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 0 0 10px 0;
`;

const SmallInputContainer = styled.div`
  display: flex;
  width: auto;
  margin: 0 30px 0 0; 
`;

const SmallInputBox = styled(SmallInput)`
  width: 104px;
  padding: 0 14px 0 0;
  border-radius: 3px;
  outline: none;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 12px;
  color: #767676;
  margin-top: -5px;
`;

const InputHeader = styled.label`
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.35px;
  color: #7f7f7f;
  margin-bottom: 7px;
`;

const InputField = styled.div`
  display: flex;
  flex-direction: column;
`;

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? 'lightblue' : '#dde7ed',
  display: 'flex',
  padding: '5px',
  overflow: 'auto',
});

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  padding: '10px',
  margin: '5px',
  background: isDragging ? '#c0ffe9' : '#f0fffa',
  ...draggableStyle,
});

/*const FieldLabel = styled(Label)`
  height: 10px;
  margin: 2px 0 8px 2px;
  font-size: 12px;
  color: #767676;
  white-space: nowrap;
`;*/

const PlaceCameras = () => {
  const { t } = useTranslation(['SetupCameras', 'Common']);
  const [validationAlert, setValidationAlert] = useState<{ key?: any, message: string, type: 'success' | 'error' | 'warning' | 'info' | undefined }>({ key: new Date(), message: '', type: undefined });

  const { completedStep, setSelectedStep, setCompletedStep } = useContext(MenuContext);
  const { pathUpdated } = useContext(PathContext);
  const { floorPlanStorage, setFloorPlanStorage } = useLocalStorage();

  const [taskspool, setTaskspool] = useState([]);
  const [tasksets, setTasksets] = useState(floorPlanStorage.tasksets.length !== 0 ? floorPlanStorage.tasksets : [{'id':0, 'name':'taskset0', 'taskList':[]}]);
  const [selectedTaskset, setSelectedTaskset] = useState(0);


  const [ maxTasksetID, setMaxTasksetID ] = useState(floorPlanStorage.maxTasksetID ? floorPlanStorage.maxTasksetID : 0);

  //関連待ちtaskpoolを作成
  useEffect(() => {
    //全task取得
    const tasks = JSON.parse(JSON.stringify(floorPlanStorage.tasks));
  
    //全関連済みtask ID取得
    const associatedpool = [];
    if (floorPlanStorage.tasksets){
      for (let i=0; i < floorPlanStorage.tasksets.length; i++) {
        if (floorPlanStorage.tasksets[i]){
          for (let k=0; k < floorPlanStorage.tasksets[i].taskList.length; k++) {
            associatedpool.push(floorPlanStorage.tasksets[i].taskList[k].id);
          }
        }
      }
    }
    //差分取る
    const newtaskspool = [];
    for (let i=0; i < tasks.length; i++) {
      if(associatedpool.indexOf(tasks[i].id) === -1) 
        newtaskspool.push(tasks[i]);
    }
    setTaskspool(newtaskspool);
  }, [floorPlanStorage]);


  /*---------dnd---------*/
  //同テーブル内の順位移動
  const reorderTasksPool = useCallback((startIndex, endIndex) => {
    const newtaskspool = [...taskspool];
    const removed = newtaskspool.splice(startIndex, 1)[0];
    newtaskspool.splice(endIndex, 0, removed);
    setTaskspool(newtaskspool);
  }, [taskspool]);
  const reorderTasksetsPool = useCallback((startIndex, endIndex) => {
    const newtasksets = [...tasksets];
    const removed = newtasksets[selectedTaskset].taskList.splice(startIndex, 1)[0];
    newtasksets[selectedTaskset].taskList.splice(endIndex, 0, removed);
    setTasksets(newtasksets);
  }, [tasksets, selectedTaskset]);

  //関連付け
  const move = useCallback((source, destination) => {
    const newtaskspool = [...taskspool];
    const newtasksets = [...tasksets];

    if (source.droppableId === 'tasksPool'){//tasksPool → tasksetsPool, 関連付け
      const removed = newtaskspool.splice(source.index, 1)[0];
      newtasksets[selectedTaskset].taskList.splice(destination.index, 0, removed);
    }else{//tasksetsPool → tasksPool, 関連外し
      const removed = newtasksets[selectedTaskset].taskList.splice(source.index, 1)[0];
      newtaskspool.splice(destination.index, 0, removed);
    }    

    setTaskspool(newtaskspool);
    setTasksets(newtasksets);
  }, [taskspool, tasksets, selectedTaskset]);

  //dnd移動判定
  const onDragEnd = useCallback((result) => {
    const { source, destination } = result;

    if (!destination) {
      return;
    }
    //同テーブル内の順位移動
    if (source.droppableId === destination.droppableId) {
      if (source.droppableId === 'tasksPool') {
        reorderTasksPool(source.index, destination.index);
      } else {
        reorderTasksetsPool(source.index, destination.index);
      }
    
    //関連付け
    } else {
      move(source, destination);
    }

    setCompletedStep(16);    
  }, [reorderTasksPool, reorderTasksetsPool, move, setCompletedStep]);
  /*---------dnd---------*/

  /*---------taskset---------*/
  const addTaskset = useCallback(() => {
    const newtaskset:any = {};
    newtaskset.id = maxTasksetID + 1;
    newtaskset.name = 'taskset'+newtaskset.id;
    newtaskset.taskList = [];
    
    //nameに重複しているかどうかチェック
    const nameList = [];
    for(let i = 0; i < tasksets.length; i++) {//既存name取得
      nameList.push(tasksets[i].name);
    }
    if (nameList.indexOf(newtaskset.name) !== -1){
      newtaskset.name = '_taskset'+newtaskset.id;
    }

    setSelectedTaskset(tasksets.length);
    setTasksets([...tasksets, newtaskset]);
    setMaxTasksetID(maxTasksetID + 1);
    setCompletedStep(16);
  }, [maxTasksetID, tasksets, setCompletedStep]);

  //taskset名変更
  const renameTaskset = useCallback((ev) => {
    //同名判定
    for(const i in tasksets){
      if(tasksets[i].name === ev.target.value) {
        setValidationAlert({ key: new Date(), message: '同名のタスクセットが存在しております。タスクセット名：' + ev.target.value, type: 'error' });
        return;
      }
    }

    const newtasksets = [...tasksets];
    newtasksets[selectedTaskset].name = ev.target.value;
    setTasksets(newtasksets);
    setCompletedStep(16);
  }, [tasksets, selectedTaskset, setCompletedStep]);

  //taskset削除
  const delTaskset = useCallback(() => {
    if (tasksets.length === 1) {
      return false;
    }

    const newtasksets = [...tasksets];
    const newtaskspool = [...taskspool];
    //関連付け済みのjobをpoolに返す
    const removedTaskset = newtasksets.splice(selectedTaskset, 1)[0];
    for (let i=0; i < removedTaskset.taskList.length; i++) {
      newtaskspool.push(removedTaskset.taskList[i]);
    }

    setTaskspool(newtaskspool);
    setTasksets(newtasksets);
    setSelectedTaskset(0);
    setCompletedStep(16);
  }, [tasksets, selectedTaskset, taskspool, setCompletedStep]);
  

  const getSelectedTaskset = useCallback((ev) => {
    for(const i in tasksets){
      if(tasksets[i].name === ev.target.value) {
        setSelectedTaskset(Number(i));
        break;
      }
    }
  }, [tasksets]);




  /*---------route---------*/
  const onContinue = useCallback((index: number) => {
    for (let i=0; i < tasksets.length; i++) {
      if (tasksets[i].taskList.length === 0){
        setValidationAlert({ key: new Date(), message: '関連付けされていない空白のタスクセットがあります。空白のタスクセットは削除してください。', type: 'error' });
        return;
      }
    }



    //開始条件が同じのtaskがあるかどうかを判定
    for (let i=0; i < tasksets.length; i++) {
      for (let k=0; k < tasksets[i].taskList.length; k++) {
        for (let n = 0; n < floorPlanStorage.jobs.length; n++) {
          //まずjob start詳細データ取得
          if (tasksets[i].taskList[k].jobList[0].id === floorPlanStorage.jobs[n].id){
            const checkJobStart = JSON.parse(JSON.stringify(floorPlanStorage.jobs[n].job_start));

            //そして同taskset内の他のtaskと比較
            for (let kk=0; kk < tasksets[i].taskList.length; kk++) {
              if ( k === kk ){
                continue;
              }
              for (let nn = 0; nn < floorPlanStorage.jobs.length; nn++) {
                if (tasksets[i].taskList[kk].jobList[0].id === floorPlanStorage.jobs[nn].id){

                  // typeの長さor中身が一致しない
                  if ( checkJobStart.type.length !== floorPlanStorage.jobs[nn].job_start.type.length ){
                    break;
                  }
                  if ( checkJobStart.type.length === floorPlanStorage.jobs[nn].job_start.type.length ){
                    const c = checkJobStart.type.filter(t => ! floorPlanStorage.jobs[nn].job_start.type.includes(t));
                    if (c.length !== 0) {
                      break;
                    }
                  }
                  
                  
                  // Start.typeが一致する場合、開始条件が同じになる可能性がある
                  let count = 0;
                  for (let loop = 0; loop < checkJobStart.type.length; loop++) {
                    switch(checkJobStart.type[loop]){
                    case 'PoseCategory':
                      if ( checkJobStart.pose_category           === floorPlanStorage.jobs[nn].job_start.pose_category &&
                           checkJobStart.pose_category_threshold === floorPlanStorage.jobs[nn].job_start.pose_category_threshold &&
                           checkJobStart.pose_category_time      === floorPlanStorage.jobs[nn].job_start.pose_category_time){
                        count++; 
                      }
                      break;
                    case 'RightHandCategory':
                      if ( checkJobStart.right_hand_category           === floorPlanStorage.jobs[nn].job_start.right_hand_category &&
                           checkJobStart.right_hand_category_threshold === floorPlanStorage.jobs[nn].job_start.right_hand_category_threshold &&
                           checkJobStart.right_hand_category_time      === floorPlanStorage.jobs[nn].job_start.right_hand_category_time){
                        count++; 
                      }
                      break;
                    case 'LeftHandCategory':
                      if ( checkJobStart.left_hand_category           === floorPlanStorage.jobs[nn].job_start.left_hand_category &&
                           checkJobStart.left_hand_category_threshold === floorPlanStorage.jobs[nn].job_start.left_hand_category_threshold &&
                           checkJobStart.left_hand_category_time      === floorPlanStorage.jobs[nn].job_start.left_hand_category_time){
                        count++; 
                      }
                      break;
                    case 'BodyParts':
                      if ( checkJobStart.body_parts      === floorPlanStorage.jobs[nn].job_start.body_parts &&
                           checkJobStart.body_area_id    === floorPlanStorage.jobs[nn].job_start.body_area_id &&
                           checkJobStart.body_parts_time === floorPlanStorage.jobs[nn].job_start.body_parts_time){
                        count++; 
                      }
                      break;
                    }
                  }
                  if ( count === checkJobStart.type.length ){
                    let msg = 'タスクセット['+tasksets[i].name+']に開始フラグは同じのタスクが含まれています。\n\r';
                    msg += '（' + tasksets[i].taskList[k].name + 'と' + tasksets[i].taskList[kk].name +'）。\n\r';
                    msg += '関連付け外すか、左メニューの「ジョブ設定」に移動して設定変更してください。';
                    setValidationAlert({ key: new Date(), message: msg, type: 'error' });
                    return;
                  }
                  break;
                }
              }
            }
          }
        }
      }
    }


  
    setFloorPlanStorage({tasksets: tasksets});
    setFloorPlanStorage({maxTasksetID});
    setSelectedStep(index);
    setCompletedStep(completedStep > 16 ? completedStep : 16);
  }, [maxTasksetID, tasksets, completedStep, floorPlanStorage, setCompletedStep, setSelectedStep, setFloorPlanStorage]);

  useEffect(() => {
    if (pathUpdated) { setSelectedStep(16); }
  }, [setSelectedStep, pathUpdated]);
  /*---------route---------*/
  return (
    <Container>
      <HeaderContainer>
        <PageHeader title='タスクセット設定' areaHref='/' areaTitle={floorPlanStorage.completed_step === 999 ? '初期設定': '設定編集'} />
        <Buttons>
          <BackButton size='small' design='secondary' onClick={() => onContinue(15)}>{t('Common:back')}</BackButton>
          <Button design='primary' size='small' onClick={() => onContinue(17)}>{t('Common:next')}</Button>
        </Buttons>
      </HeaderContainer>

      {validationAlert.message !== '' &&
        <ValidationAlert type={validationAlert.type} message={validationAlert.message} />}

  
      <InputContainer>
        <Position>
          <InputHeader>タスクセット追加</InputHeader>
          <SmallInputContainer>
            <InputField>
              <Button design='primary' size='small' onClick={addTaskset}>add</Button>
            </InputField>
          </SmallInputContainer>
        </Position>
      </InputContainer>

      <InputContainer>
        <Position>
          <InputHeader>タスクセット選択</InputHeader>
          <SmallInputContainer>
            <SelectFieldBox value={tasksets[selectedTaskset].name} onChange={getSelectedTaskset}>
              {tasksets.map((item)=>{
                return <option key={'tasksetname_'+item.name} value={item.name}>{item.name}</option>;
              })}
            </SelectFieldBox>
          </SmallInputContainer>
        </Position>
        
        <Position>
          <InputHeader>タスクセット名</InputHeader>
          <SmallInputContainer>
            <InputField>
              <SmallInputBox label='' value={tasksets[selectedTaskset].name} onChange={renameTaskset} />
            </InputField>
          </SmallInputContainer>
        </Position>

        <Position>
          <InputHeader>開始フラグ</InputHeader>
          <SmallInputContainer>
            <InputField>
              <SmallInputBox label='' value={tasksets[selectedTaskset].taskList.length>0 ? tasksets[selectedTaskset].taskList[0].name : ''} />
            </InputField>
          </SmallInputContainer>
        </Position>

        <Position>
          <InputHeader>終了フラグ</InputHeader>
          <SmallInputContainer>
            <InputField>
              <SmallInputBox label='' value={tasksets[selectedTaskset].taskList.length>0 ? tasksets[selectedTaskset].taskList[(tasksets[selectedTaskset].taskList.length-1)].name : ''} />
            </InputField>
          </SmallInputContainer>
        </Position>

        <Position>
          <InputHeader>タスクセット削除</InputHeader>
          <SmallInputContainer>
            <Button size='small' design='primary' onClick={delTaskset}>－</Button>
          </SmallInputContainer>
        </Position>
      </InputContainer>

      <DragDropContext onDragEnd={onDragEnd}>
        <InputContainer>
          <Position>
            <InputHeader>{tasksets[selectedTaskset].name}に関連付け済みタスク</InputHeader>
          </Position>
        </InputContainer>
        <Droppable droppableId='tasksetsPool' direction='horizontal'>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {tasksets[selectedTaskset].taskList.map((item, index) => {
                return (
                  <Draggable key={`tasksetsPool-${index}`} draggableId={`tasksetsPool-${index}`} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        {item.name}
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        <hr />
        <TasksListTitle>
          <Position>
            <InputHeader>関連付け待ちタスク</InputHeader>
          </Position>
        </TasksListTitle>
        <Droppable droppableId='tasksPool' direction='horizontal'>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {taskspool.map((task, index) => {
                return (
                  <Draggable key={`tasksPool-${index}`} draggableId={`tasksPool-${index}`} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        {task.name}
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

    </Container>
  );
};

export default PlaceCameras;
